import { render, staticRenderFns } from "./StaticPagesControl.vue?vue&type=template&id=6479e8b0&"
import script from "./StaticPagesControl.vue?vue&type=script&lang=js&"
export * from "./StaticPagesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports